import React, { useState, useContext, useRef, useEffect } from 'react';
import { withRouter } from 'react-router-dom';
import { AsyncModel, AsyncModelClose } from '../AsyncModel/AsyncModel';
import ReactLoading from 'react-loading';
import { CusButton } from '../../Components/From/Button';
import Tool_CusFilter from '../../Components/Tools/Tool_CusFilter';
import { FormattedMessage } from 'react-intl';
import { Global } from '../../App';
import { browserName } from 'react-device-detect';
import Tooltip from 'rc-tooltip';
import Tool_circulatingTab from '../../Components/Tools/Tool_circulatingTab';
import PerfectScrollbar from 'react-perfect-scrollbar';
import _ from 'lodash';
import cls from 'classnames'
import moment from 'moment';
import '../../Pages/pages.scss';
// switch lang
import { langStringToCode } from '../../Share/Tools/switchLang';
// api
import { getOrderProductList } from '../../Api/staff/GetOrderInfo';
import { getTranslationStaffInfo } from '../../Api/staff/GetStaffInfo';
import { getTagList } from '../../Api/GetProduct';

import defaultImg from '../../Resource/image/icons/img_no_image.png';
import ScrollTabs from '../../Components/Common/ScrollTabs'
import { useMemo } from 'react';
/**
 *
 * @param {object} props
 * 本次步驟會影響的global state
 *
 * staffInfo.currentCheckOrderStep (3.1 => 3.1 || 3.2)
 *
 */

function StaffOrderStep_3(props) {
  // const { location } = props;
  const { globalState, dispatchGlobal } = useContext(Global);
  const [state, setState] = useState({
    currentCategory: null,
    searchInput: '',
    categoryList: [], // tab
    mealList: [], // meals
    tagList: {}, //tags
    tagSelected: [],
    tagPopupToggle: false,
    totalPrice: 0,
    totalMealKind: 0
  });
  const _menuListRef = useRef([]);

  async function apiOrderProductList(orderCode, langId, storeID, createAt) {
    const backToStep3 = () => {
      dispatchGlobal({
        type: 'UPDATE',
        payload: [
          {
            key: 'staffInfo',
            val: {
              ...globalState.staffInfo,
              currentCheckOrderStep: '3'
            }
          }
        ]
      });
    };
    
    try {
      const waittingAlert = AsyncModel({
        content: (
          <div className="w-100 d-flex justify-content-center">
            <ReactLoading
              type="spokes"
              color="#ccc"
              height="100px"
              width="100px"
            />
          </div>
        ),
        showConfirmBtn: false
      });
      const res = await getOrderProductList(orderCode, langId, storeID, createAt);
      AsyncModelClose();
      const { errCode, orderAddProduct } = res.data;
      if (errCode == 200) {
        // 分類tabs
        let _categoryList = [];
        // let _categoryList = orderAddProduct.categoryList.map(e => ({
        //   title: e.name,
        //   type: e.id
        // }));
        // let _categoryList = orderAddProduct.categoryList.filter(e =>
        //   // 只顯示門市可用
        //   (e.type_order_mode === 1 || e.type_order_mode === 3)
        // ).map(e => ({
        //   title: e.name,
        //   type: e.id
        // }));
        // 餐點總攬
        let _mealList = orderAddProduct.categoryList.map(e => {
          let type = e.id;
          let typeName = e.name;
          // 分類同時push進去
          _categoryList.push({
            title: e.name,
            type
          });
          let newArr = e.product.map(_product => ({
            type: type,
            typeName: typeName,
            title: _product.name,
            description: _product.description,
            ..._product
          }));
          // let newArr = e.product.filter(_product =>
          //   // 只顯示門市可用
          //   (_product.order_mode === 1 || _product.order_mode === 3)
          // ).map(_product => ({
          //   type: type,
          //   typeName: typeName,
          //   title: _product.name,
          //   description: _product.description,
          //   ..._product
          // }));
          return newArr;
        });
        _mealList = _.flatten(_mealList);
        return {
          currentCategory: _categoryList[0],
          categoryList: _categoryList,
          mealList: _mealList,
          totalPrice: orderAddProduct.totalPrice,
          totalMealKind: orderAddProduct.totalMealKind,
          countryName: orderAddProduct.countryName,
          storeName: orderAddProduct.storeName
        };
      } else {
        const Alert = await AsyncModel({
          title: globalState.langFile[`errorMsg.errorCode_${errCode}`],
          confirmBtnText: globalState.langFile['popup.buttonConfirm']
        });
        if (Alert) return backToStep3();
      }
    } catch (err) {
      console.error('OrderProductList error.');
      const Alert = await AsyncModel({
        title: globalState.langFile[`errorMsg.errorCode_${407}`],
        confirmBtnText: globalState.langFile['popup.buttonConfirm']
      });
      if (Alert) return backToStep3();
    }
  }

  async function apiTranslationStaffInfo(staffId, storeId, langId) {
    try {
      const res = await getTranslationStaffInfo(staffId, storeId, langId);
      const { errCode, response } = res.data;
      if (errCode == 200) {
        return response;
      } else {
        console.error('TranslationStaffInfo error.', errCode);
      }
    } catch (err) {
      console.error('TranslationStaffInfo error.');
    }
  }

  async function apiGetTagList(langId) {
    try {
      const res = await getTagList(langId);
      const { errCode, tagList } = res.data;
      if (errCode == 200) {
        return tagList;
      } else {
        console.error('GetTagList error.', errCode);
      }
    } catch (err) {
      console.error('GetTagList error.');
    }
  }

  // get api 當lang改變時重call api
  useEffect(() => {
    const handler = async () => {
      const orderCode = globalState.staffInfo.orderCode ? globalState.staffInfo.orderCode : globalState.staffInfo.checkOrderData.orderCode;
      const staffCode = globalState.staffInfo.checkOrderStaff.staffCode;
      const storeCode = globalState.staffInfo.checkOrderBranch.branchCode;
      const langCode = langStringToCode(globalState.langType);
      const storeID = globalState.staffInfo.checkOrderBranch.branchCode;
      const createAt = moment(globalState.staffInfo.checkOrderData.orderTime).format('YYYY/MM/DD');
      const orderProductList = await apiOrderProductList(orderCode, langCode, storeID, createAt);
      const translateStaff = await apiTranslationStaffInfo(
        staffCode,
        storeCode,
        langCode
      );
      const tagList = await apiGetTagList(langCode);

      if (orderProductList && translateStaff && tagList) {
        setState(curr => {
          let newState = { ...curr };
          newState.currentCategory = orderProductList.currentCategory;
          newState.categoryList = orderProductList.categoryList;
          newState.mealList = orderProductList.mealList.map(meal => {
            meal.mealTag = meal.allergen.concat(meal.recommend);
            return meal;
          });
          newState.tagList = tagList;
          newState.totalPrice = orderProductList.totalPrice;
          newState.totalMealKind = orderProductList.totalMealKind;
          return newState;
        });
        dispatchGlobal({
          type: 'UPDATE',
          payload: [
            {
              key: 'staffInfo',
              val: {
                ...globalState.staffInfo,
                allergenTags: tagList.allergenMenu.concat(tagList.allergenMenu).map(m => (m.id)),
                veganTags: tagList.vegetarian,
                checkOrderData: {
                  ...globalState.staffInfo.checkOrderData,
                  country: {
                    ...globalState.staffInfo.checkOrderData.country,
                    countryName: orderProductList.countryName
                  },
                  branch: {
                    ...globalState.staffInfo.checkOrderData.branch,
                    branchName: orderProductList.storeName
                  }
                },
                checkOrderBranch: {
                  ...globalState.staffInfo.checkOrderBranch,
                  branchName: translateStaff.storeName
                }
              }
            }
          ]
        });
      }
    };

    handler();
  }, [globalState.langType]);

  // scroll定位在上次選取的項目
  useEffect(() => {
    window.document.body.scrollTop = globalState.staffInfo.lastSelectedItemScrolltop || 0;
  }, [state.mealList]);

  const $tabs = useMemo(() => {
    if (state.categoryList !== undefined) {
      let filterArray = [];
      // 有輸入關鍵字
      if (state.searchInput || state.tagSelected || state.veganSelected) {
        // 找出有該關鍵字的分類type
        let t = state.mealList
          // 關鍵字篩選
          .filter(f => {
            const target = state.searchInput;

            return (
              f.searchNum.toString().indexOf(target) > -1 ||
              f.name.toLowerCase().indexOf(target.toLowerCase()) > -1
            );
          })
          // 標籤篩選
          .filter(f => {
            // 沒有全選標籤時
            if (globalState.staffInfo.filterTag && globalState.staffInfo.filterTag.length) {
              // 有篩選條件
              if (globalState.staffInfo.filterTag.length) {
                return globalState.staffInfo.filterTag.every(i => (
                  f.allergenMenu.map(m => (m.id)).includes(i)
                ))
              } else {
                return f.allergenMenu.length === 0;
              }
            } else {
              return true;
            }
          }).filter(f => {
            if(globalState.staffInfo.filterVegan && globalState.staffInfo.filterVegan.length &&
              globalState.staffInfo.filterVegan.length !== state.tagList.vegetarian.length) {
                if(globalState.staffInfo.filterVegan.length){
                  return globalState.staffInfo.filterVegan.some(i => (
                    f.vegetarian.map(m=> (m.id)).includes(i)
                  ))
                } else {
                  return f.vegetarian.length === 0;
                }
            } else {
              return true;
            }            
          });

          filterArray = [...new Set(t.map(item => (item.type)))];

        // 轉換回文字
        const filterTabs = state.categoryList
          .filter(({ type: id1 }) =>
            filterArray.some((id2) =>
              id2 === id1
            ));

        // 有結果
        if (filterTabs.length) {
          let result = filterTabs.map(item => ({
            title: item.title,
            value: item.type,
            count: (filterTabs.length === state.categoryList.length) ? 0 : t.filter(cnt => { return cnt.type === item.type}).length
          }));

          setState(curr => {
            return {
              ...curr,
              filterCategoryList: result,
            };
          })

          return result  
        } else {
          // 查無結果，顯示全分類
          return state.categoryList.map(item => ({
            title: item.title,
            value: item.type,
            count: 0
          }))
        }
      } else {
        if(state.filterCategoryList !== undefined){
          return state.filterCategoryList.map(item => ({
            title: item.title,
            value: item.type,
            count: (state.filterCategoryList.length == state.categoryList.length)? 0 : item.count
          })) 
        } 

        return state.categoryList.map(item => ({
          title: item.title,
          value: item.type,
          count: 0
        }))
      }
    }
    return []
  }, [state.categoryList, state.searchInput, state.tagSelected, state.veganSelected])

  const $allTabs = useMemo(() => {
    if (state.categoryList !== undefined) {
      return state.categoryList.map(item => ({
        title: item.title,
        value: item.type
      }))
    }
    return []
  }, [state.categoryList])

  const $tabItems = useMemo(() => {
    if (state.mealList !== undefined) {
      if (state.searchInput) {
        // 輸入關鍵字移動到上方
        const { y } = document.getElementsByClassName('ScrollTabs')[0].getBoundingClientRect()
        document.body.scrollTo({
          top: document.body.scrollTop + y,
          behavior: 'smooth'
        })

        return state.mealList
          // 標籤篩選
          .filter(f => {
            // 沒有全選標籤時
            if (globalState.staffInfo.filterTag && globalState.staffInfo.filterTag.length) {
              // 有篩選條件
              if (globalState.staffInfo.filterTag.length) {
                return globalState.staffInfo.filterTag.every(i => (
                  f.allergenMenu.map(m => (m.id)).includes(i)
                ))
              } else {
                return f.allergenMenu.length === 0;
              }
            } else {
              return true;
            }
          })
          .filter(f => {
            if(globalState.staffInfo.filterVegan && globalState.staffInfo.filterVegan.length &&
               globalState.staffInfo.filterVegan.length !== state.tagList.vegetarian.length) {
                if(globalState.staffInfo.filterVegan.length){
                  return globalState.staffInfo.filterVegan.some(i => (
                    f.vegetarian.map(m=> (m.id)).includes(i)
                  ))
                } else {
                  return f.vegetarian.length === 0;
                }
            } else {
              return true;
            }            
          })
          // 關鍵字篩選
          .filter(f => {
            const target = state.searchInput;
            return (
              f.searchNum.toString().indexOf(target) > -1 ||
              f.name.toLowerCase().indexOf(target.toLowerCase()) > -1
            );
          })
          .map(item => ({
            $tab: item.type,
            ...item
          }))
      } else {
        return state.mealList
          // 標籤篩選
          .filter(f => {
            // 沒有全選標籤時
            if (globalState.staffInfo.filterTag && globalState.staffInfo.filterTag.length) {
              // 有篩選條件
              if (globalState.staffInfo.filterTag.length) {
                return globalState.staffInfo.filterTag.every(i => (
                  f.allergenMenu.map(m => (m.id)).includes(i)
                ))
              } else {
                return f.allergenMenu.length === 0;
              }
            } else {
              return true;
            }
          })
          .filter(f => {
            if(globalState.staffInfo.filterVegan && globalState.staffInfo.filterVegan.length &&
              globalState.staffInfo.filterVegan.length !== state.tagList.vegetarian.length) {
                if(globalState.staffInfo.filterVegan.length){
                  return globalState.staffInfo.filterVegan.some(i => (
                    f.vegetarian.map(m=> (m.id)).includes(i)
                  ))
                } else {
                  return f.vegetarian.length === 0;
                }
            } else {
              return true;
            }            
          })
          .map(item => ({
            $tab: item.type,
            ...item
          }))
      }
    }
    return []
  }, [state.mealList, state.searchInput, state.tagSelected, state.veganSelected])
  return (
    <>
      <div className="d-flex align-items-center justify-content-center txtColorBrown mb-3">
        <span className="m-2">
          {globalState.staffInfo.checkOrderBranch.branchName}
        </span>
        <span className="m-2">
          {globalState.staffInfo.checkOrderGroup.groupName}
        </span>
        <span className="m-2">
          {globalState.staffInfo.checkOrderStaff.staffName}
        </span>
        <span className="m-2">
          {globalState.staffInfo.checkOrderStaff.staffNum}
        </span>
      </div>
      <div className="Pages__space">
        <div className="Pages__space__item d-flex flex-wrap align-items-center p-2 p-sm-3">
          <div className="d-flex align-items-center p-0 col-12 col-sm-4 pt-2 pb-2">
            <span className="mr-2">
              {globalState.staffInfo.checkOrderData.branch.branchName}
            </span>
            <span className="mr-2">
              {globalState.staffInfo.checkOrderData.numberOfAdult}
              <FormattedMessage id="pages.staffCheckOrder.orderInfo.numberOfAdult" />
            </span>
            <span className="mr-2">
              {globalState.staffInfo.checkOrderData.numberOfChild}
              <FormattedMessage id="pages.staffCheckOrder.orderInfo.numberOfChild" />
            </span>
            <span className="mr-2">
              {globalState.staffInfo.checkOrderData.country.countryName}
            </span>
          </div>
          <div className="p-0 col-6 col-sm-4 pt-2 pb-2">
            <FormattedMessage id="pages.staffCheckOrder.orderInfo.queueNumber" />
            <span className="ml-2 txtColorBrown orderInfo">
              {globalState.staffInfo.checkOrderData.queueNumber}
            </span>
          </div>
          <div className="p-0 col-6 col-sm-4 pt-2 pb-2">
            <FormattedMessage id="pages.staffCheckOrder.orderInfo.queueCode" />
            <span className="ml-2 txtColorRed orderInfo">
              {globalState.staffInfo.checkOrderData.queueCode}
            </span>
          </div>
          <div className="p-0 col-12  pt-2 pb-2">
            <span className="mr-2">
              <FormattedMessage id="pages.staffCheckOrder.orderInfo.time" />
            </span>
            <span className="mr-2">
              {globalState.staffInfo.checkOrderData.orderTime}
            </span>
          </div>
        </div>
      </div>
      <FormattedMessage
        id="pages.staffCheckOrder.step3_1.searchMenuInputPlaceholder"
        children={msg => {
          return (
            <ScrollTabs
              tabs={$tabs}
              allTabs={$allTabs}
              items={$tabItems}
              searchPlaceholder={msg}
              menuType={globalState.staffInfo.menuType}
              isFillFilter={(globalState.staffInfo.filterTag && globalState.staffInfo.filterTag.length > 0)|| (globalState.staffInfo.filterVegan && globalState.staffInfo.filterVegan.length > 0)}
              itemOnSelected={() => {
                setState(curr => {
                  let newState = { ...curr };
                  newState.searchInput = '';
                  return newState;
                });
              }}
              openFilter={() => {
                setState(curr => {
                  let newState = { ...curr };
                  newState.tagPopupToggle = true;
                  return newState;
                });
              }}
              searchOnChange={(val) => {
                setState(curr => {
                  let newState = { ...curr };
                  newState.searchInput = val;
                  return newState;
                });
              }}
              menuTypeSwitch={() => {
                dispatchGlobal({
                  type: 'UPDATE',
                  payload: [
                    {
                      key: 'staffInfo',
                      val: {
                        ...globalState.staffInfo,
                        menuType: globalState.staffInfo.menuType === 1 ? 2 : 1
                      }
                    }
                  ]
                });
              }}
              renderItem={(itemInfo, index) => (
                <div
                  key={index}
                  className={cls('Pages__meals pt-2 pt-sm-4 pb-2 pb-sm-4',
                    itemInfo.product_status === 3 ? ' isSoldOut' : '',
                    globalState.staffInfo.menuType === 1 ? 'isRwd' : ''
                  )}
                  ref={ref => {
                    if (ref && _menuListRef.current.filter(e => e === ref) < 1) {
                      _menuListRef.current.push(ref);
                    }
                  }}
                  onClick={() => {
                    // 正常銷售才可進入
                    if (itemInfo.product_status === 2) {
                      dispatchGlobal({
                        type: 'UPDATE',
                        payload: [
                          {
                            key: 'staffInfo',
                            val: {
                              ...globalState.staffInfo,
                              lastSelectedItemScrolltop: window.document.body.scrollTop,
                              currMealDetail: itemInfo,
                              currentCheckOrderStep: '3.2'
                            }
                          }
                        ]
                      });
                    }
                  }}
                >
                  <div className="Pages__meals__imgBoxBlock d-flex">
                    <div className="Pages__meals__imgBox">
                      <img src={itemInfo.img ? itemInfo.img : defaultImg} alt="" />
                      {/* 單一產品總數 */}
                      {/* {console.log("itemInfo",itemInfo)} */}
                      {(() => {
                        if (itemInfo.orderQuantity > 0) {
                          return (
                            <div className="Pages__meals__notes d-flex justify-content-center align-items-center">
                              <span>{itemInfo.orderQuantity}</span>
                            </div>
                          );
                        } else {
                          return null;
                        }
                      })()}
                    </div>
                    <div className={cls("Pages__meals__info d-flex flex-column flex-sm-row",
                      globalState.staffInfo.menuType === 1 ? '' : 'col justify-content-center justify-content-sm-start align-items-sm-center',
                      globalState.langType
                    )}>
                      <div className="d-flex flex-column col-sm p-0">
                        <span className="Pages__meals__title mt-1 mb-1 mt-sm-2 mb-sm-2">
                          {itemInfo.title}
                        </span>
                        <div className="Pages__meals__icon d-flex flex-wrap mt-1 mb-1 mt-sm-2 mb-sm-2">
                          {itemInfo.recommend.map((recommendInfo, index) => (
                            <Tooltip
                              key={index}
                              placement="bottom"
                              trigger={['hover', 'click']}
                              overlay={<span children={recommendInfo.description} />}
                            >
                              <img
                                style={{ height: '25px' }}
                                className="mr-1"
                                src={recommendInfo.icon}
                                alt=""
                                onClick={e => {
                                  e.stopPropagation();
                                }}
                              />
                            </Tooltip>
                          ))}
                        </div>
                        {
                          globalState.staffInfo.menuType === 1 ? (
                            <div className="d-flex mx-auto">
                              <span className="mt-1 mb-1 mt-sm-2 mb-sm-2 d-inline-block d-sm-none">
                                $ {itemInfo.price}
                              </span>
                              {
                                itemInfo.product_status === 3 ? (
                                  <span className="mt-1 mb-1 ml-2 mr-sm-2 mt-sm-2 mb-sm-2">
                                    <FormattedMessage id="pages.staffCheckOrder.step3_1.soldOut" />
                                  </span>
                                ) : null
                              }
                              <span className="mt-1 mb-1 mt-sm-2 mb-sm-2 d-sm-inline-block d-none">
                                $ {itemInfo.price}
                              </span>
                            </div>
                          ) : null
                        }
                      </div>
                      {
                        globalState.staffInfo.menuType === 1 ? null : (
                          <div className="d-flex justify-content-sm-end">
                            <span className="mt-1 mb-1 mt-sm-2 mb-sm-2 d-inline-block d-sm-none">
                              $ {itemInfo.price}
                            </span>
                            {
                              itemInfo.product_status === 3 ? (
                                <span className="mt-1 mb-1 ml-2 mr-sm-2 mt-sm-2 mb-sm-2">
                                  <FormattedMessage id="pages.staffCheckOrder.step3_1.soldOut" />
                                </span>
                              ) : null
                            }
                            <span className="mt-1 mb-1 mt-sm-2 mb-sm-2 d-sm-inline-block d-none">
                              $ {itemInfo.price}
                            </span>
                          </div>
                        )
                      }
                    </div>
                  </div>
                </div>
              )}
            />
          )
        }}
      />
      {/* notes */}
      <div
        className="Pages__notes pl-4 pr-4 p-sm-0"
        style={{ cursor: 'pointer' }}
        onClick={() => {
         
          if (state.mealList.length > 0 && state.totalPrice>0) {
            dispatchGlobal({
              type: 'UPDATE',
              payload: [
                {
                  key: 'staffInfo',
                  val: {
                    ...globalState.staffInfo,
                    lastSelectedItemScrolltop: null,
                    currentCheckOrderStep: '3'
                  }
                }
              ]
            });
            window.document.body.scrollTop = 0;
          }
        }}
      >
        <div className="p-0 pt-2 pb-2 d-flex justify-content-between align-items-center">
          <div className="d-flex align-items-end">
            
            <FormattedMessage id="pages.staffCheckOrder.step3_1.notesChoosed" />
            <span className="mr-2 ml-2 Pages__notes__focusText">
              {state.totalMealKind}
            </span>
            <FormattedMessage id="pages.staffCheckOrder.step3_1.notesUnit" />
            <FormattedMessage id="pages.staffCheckOrder.step3_1.notesTotalAmount" />
            <span className="mr-2 ml-2 Pages__notes__focusText">
              $ {state.totalPrice} 
            </span>
          </div>
          <CusButton.Red
            className="pt-2 pb-2 ml-2"
            style={{ flexGrow: 1, maxWidth: 150 }}
            disabled={state.mealList.length <= 0 || state.totalPrice==0}
            children={
              <FormattedMessage id="pages.staffCheckOrder.step3_1.notesButtonSaveOrder" />
            }
          />
        </div>
      </div>
      {/* 標籤篩選視窗 */}
      {(() => {
        if (!state.tagPopupToggle) return null;
        return (
          <Tool_CusFilter
            tagGroup={state.tagList}
            selectedItems={globalState.staffInfo.filterTag}
            selectedVeganItems ={globalState.staffInfo.filterVegan}
            onClose={() => {
              setState(curr => {
                return {
                  ...curr,
                  tagPopupToggle: false
                };
              });
            }}
            onSelectItem={tagIds => {
              setState(curr => {
                return {
                  ...curr,
                  tagSelected: tagIds.allergen,
                  veganSelected: tagIds.vegan
                };
              });
              dispatchGlobal({
                type: 'UPDATE',
                payload: [
                  {
                    key: 'staffInfo',
                    val: {
                      ...globalState.staffInfo,
                      filterTag: tagIds.allergen,
                      filterVegan: tagIds.vegan,
                    }
                  }
                ]
              });
            }}
          />
        );
      })()}
    </>
  );
}

export default withRouter(StaffOrderStep_3);
